import { render } from "./AccountDetailsContactsTab.vue?vue&type=template&id=d3718b3c"
import script from "./AccountDetailsContactsTab.vue?vue&type=script&lang=js"
export * from "./AccountDetailsContactsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__